const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

const NEW_VIEW_TOTAL = 598802;
const DATA_POINT_VIEWS = 516169;

const SCALE_FACTOR = (NEW_VIEW_TOTAL / DATA_POINT_VIEWS);

module.exports.reportData = {
  info: {
    campaignName: 'VOXI Endless Challenge',
    influencerName: 'Callux, Caspar Lee and Oli White',
    reportDate: new Date('2018-04-16'),
    hasLogo: true,
    campaignHashTag: '#VOXIendlesschallenge',
    campaignSponsorHandle: '@VOXI_UK',
    campaignArchive: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/campaign-archives/voxi-endless-challenge.zip',
  },
  youtubeViews: NEW_VIEW_TOTAL,
  youtubeEngagements: 30391 * SCALE_FACTOR,
  scaleFactor: SCALE_FACTOR,
  heroData: {
    main: {
      title: 'I CAUGHT A FOOTBALL FROM 400FT',
      subTitle: `Yes. 400ft.
          Grab your exclusive VOXI SIM pack here https://www.voxi.co.uk/callux
          This video is part of a paid collaboration with VOXI

          Take part in the #VOXIendlesschallenge!`,
      videoUrl: 'https://www.youtube.com/watch?v=C5ugU5DnfmE',
      views: NEW_VIEW_TOTAL,
      engagements: 30391 * SCALE_FACTOR,
      watchTimeUKIre: 1147241 * SCALE_FACTOR,
      watchTimeTotal: 1761328 * SCALE_FACTOR,
      scaleFactor: SCALE_FACTOR,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [92.7, 7.3],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [10.8, 39.6, 26.4, 8.3, 5.9, 0.7, 1],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [1.2, 3.2, 1.3, 0.9, 0.7, 0.1, 0.1],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 1082958,
        views: 310234,
        likes: 17308,
      },
      {
        name: 'United States',
        watchTime: 138773,
        views: 45548,
        likes: 2391,
      },
      {
        name: 'Australia',
        watchTime: 82003,
        views: 22499,
        likes: 1408,
      },
      {
        name: 'Ireland',
        watchTime: 64283,
        views: 18956,
        likes: 1107,
      },
      {
        name: 'Netherlands',
        watchTime: 37349,
        views: 10903,
        likes: 605,
      },
    ],
    },
    supportingData: {
      labels: [
        'instagram',
        'instagram STORY',
        'twitter',
      ],
      datasets: [{
        data: [0, 204561, 777553],
        backgroundColor: [
          dyzioPalette.bgPink,
          dyzioPalette.bgGreen,
          dyzioPalette.blue,
        ],
        borderColor: [
          dyzioPalette.pink,
          dyzioPalette.green,
          dyzioPalette.bgBlue,
        ],
        borderWidth: 1,
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/voxi-endless-challenge-2018.js